import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n        Assign Admin\n      ")
], -1);
const _hoisted_3 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_4 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "p-8" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "Select the admin you would like to assign this leaver request to:", -1);
const _hoisted_8 = {
    key: 1,
    class: "border border-gray-300 rounded-lg p-6"
};
const _hoisted_9 = { class: "flex justify-end" };
const _hoisted_10 = { class: "mt-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerName",
    class: "block text-sm font-medium text-gray-700"
}, "Admin name", -1);
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "col-span-6 mt-4" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerEmail",
    class: "block text-sm font-medium text-gray-700"
}, "Admin email address:", -1);
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "mt-4 flex justify-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_search = _resolveComponent("user-search");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (!_ctx.user.userId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            _createVNode(_component_user_search, {
                                group: "H2R",
                                onUpdatedUser: _cache[0] || (_cache[0] = ($event) => (_ctx.handleUser($event)))
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_XIcon, {
                                    class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                    onClick: _ctx.handleClearUser
                                }, null, 8, ["onClick"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.user.name,
                                    type: "text",
                                    name: "hiringManagerName",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: ""
                                }, null, 8, _hoisted_12)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.user.email,
                                    type: "email",
                                    name: "hiringManagerEmail",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: ""
                                }, null, 8, _hoisted_15),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.confirmAssignAdmin && _ctx.confirmAssignAdmin(...args)))
                                    }, "Assign Admin")
                                ])
                            ])
                        ]))
                ])
            ])
        ])
    ]));
}
